var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGhost = function SvgGhost(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "m5.253 16.597-.35.281A.557.557 0 0 1 4 16.444V8c0-3.312 2.688-6 6-6 3.313 0 6 2.688 6 6v8.444a.557.557 0 0 1-.903.434l-.35-.281a1 1 0 0 0-1.378.122l-.953 1.093a.552.552 0 0 1-.832 0l-.83-.953a1 1 0 0 0-1.507 0l-.831.953a.552.552 0 0 1-.832 0l-.953-1.093a1 1 0 0 0-1.378-.122M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGhost);
export default ForwardRef;